// When loading the oris website as an iframe we have some restrictions like no header or footer (ORIS-2886)
// Recommended way to load the Oris website as an iFrame:
// <iframe src="https://oris.lndo.site/de-CH?iframe=true" width="100%" onload="this.height = document.body.scrollHeight + 'px';" style="border-width: 1px 0 1px 0"></iframe>

export default function () {
  const route = useRoute()
  const iframeQueryValue = route?.query.iframe
  return computed(() => iframeQueryValue === 'true')
}
